import React, { FC } from 'react'

import { IconShoppingCheckoutProps } from './IconShoppingCheckout.types'
import * as Styled from './styles/IconShoppingCheckout.style'

import { nonThemeableRules } from '../../ruleSet'

const IconShoppingCheckout: FC<IconShoppingCheckoutProps> = ({
  size = nonThemeableRules.defaultSize as number as IconShoppingCheckoutProps['size'],
  isResponsive = false,
}: IconShoppingCheckoutProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M12.875 19H39.05v19.965a4.016 4.016 0 0 1-4.035 4H12.873a4.022 4.022 0 0 1-4.045-4V23a4.02 4.02 0 0 1 4.04-4h.007Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M14.898 19v-5c0-4.96 4.075-8.983 9.102-8.983 5.028 0 9.103 4.023 9.103 8.983v5'
          stroke='#0D0D0D'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M14.898 24.997c.559 0 1.012-.446 1.012-.997 0-.551-.453-.998-1.012-.998-.56 0-1.013.447-1.013.998 0 .55.453.997 1.013.997Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M14.898 24.625c.349 0 .632-.28.632-.625a.629.629 0 0 0-.632-.625c-.35 0-.633.28-.633.625s.283.625.633.625Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M14.898 24.25a.251.251 0 0 0 .252-.25.251.251 0 0 0-.252-.25.251.251 0 0 0-.253.25c0 .138.113.25.253.25Zm18.204.747c.56 0 1.013-.446 1.013-.997 0-.551-.453-.998-1.013-.998-.559 0-1.012.447-1.012.998 0 .55.453.997 1.012.997Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M33.102 25.957c1.098 0 1.988-.876 1.988-1.957s-.89-1.957-1.988-1.957c-1.097 0-1.987.876-1.987 1.957s.89 1.957 1.988 1.957Z'
          fill='#E60000'
        />
        <path
          d='M33.102 24.625c.35 0 .633-.28.633-.625a.629.629 0 0 0-.633-.625c-.349 0-.632.28-.632.625s.283.625.633.625Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M14.898 25.935c1.082 0 1.96-.866 1.96-1.935s-.878-1.935-1.96-1.935c-1.083 0-1.96.866-1.96 1.935s.877 1.935 1.96 1.935Z'
          fill='#E60000'
        />
        <path
          d='M33.102 24.25c.14 0 .253-.112.253-.25a.251.251 0 0 0-.252-.25.251.251 0 0 0-.253.25c0 .138.113.25.252.25Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconShoppingCheckout
